module Tapas.Bindings {
    export class ProductSpecsReadMore {
        public init(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

            var value = valueAccessor();

            const container = $(element);
            const toggler = container.find('.js-toggle-read-more');
            const readMoreContent = container.find('.js-read-more-content');

            toggler.click(() => {
                if (toggler.hasClass('open')) {
                    container.height(255);
                    toggler.toggleClass('open');
                }
                else {
                    container.height(readMoreContent.height() + toggler.height() + 30);
                    toggler.toggleClass('open');
                }
            });
        }
    }
    ko.bindingHandlers['productSpecsReadMore'] = new ProductSpecsReadMore();
} 
